import { faEdit, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, isEmptyArray } from "formik";
import { get, isEmpty, isString } from "lodash";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import {
  ConfigureCommunicationField,
  ContentPreviewer,
  EmployeeDetailsCard,
  LoaderWrapper,
  ManageDistributionLayout,
  PlanCards,
  SliderPanel,
  UploadComponentLoans,
  UploadComponentWithDrawalSpousal,
  FormLeaveGuard,
  FieldMultiSelectButtonGroup,
  ManageDistributionLayoutNew,
  WithDrawalCard,
  EmployeeSliderDetails,
} from "../../../components";
import {
  distributionFormFields,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getPathWithParam,
  manageDistributionFormNames,
  MANAGE_CENSUS_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  uploadDocumentThrough,
} from "../../../utils";
import AnnutizationDetails from "./AnnutizationDetails";
import BasicDetailsCard from "./BasicDetailsCard";
import DistributionModeSummaryCard from "./DistributionModeSummaryCard";
import SpecificTenureDetails from "./SpecificTenureDetails";
import RequestSummaryCard from "../../../components/RequestSummaryCard";
import { useHistory } from "react-router-dom";
import PaymentScheduleTable from "./PaymentScheduleTable";
import {
  getCountriesList,
  getEmployeeCensusInformation,
  getEmployeePlanWithdrawals,
  getStates,
  getStateTax,
  getWithdrawalRequest,
  getPeriodicPaymentCalculationDetails,
} from "../../../services";
import { useDeepEffect, useRouterParams, useRequest } from "../../../abstracts";
import {
  cacheWithdrawalRequestPageLevelData,
  manageDistributionStore,
  MANAGE_DISTRIBUTION_POST_API_ERROR,
  saveRequest,
  setCensusDataFromAPI,
  setManageDistributionToastInfo,
  setWithdrawalRequestPageData,
  uploadWithdrawalDocuments,
} from "../../../contexts";
import { useContext } from "react";
import {
  calculateGrossAmountFromNetAmountSourceWise,
  CalculateProrationSplitUp,
  calculateRequestedAmountEffective,
  getVestedBalanceWithoutVestingMultiplier,
  calculationToBeBasedOnGrossAmount,
  DeductProratedSplits,
  getFilteredRkData,
  SourceBalancesAfterVestingMultiplier,
  calculateTotalVestedBalanceFromSourceBalance,
  getPeriodicPaymentType,
  isSpecificTenure,
  isSpecificDollar,
  isPartialWithdrawal,
  withdrawalTypeEnum,
  isQBAD,
} from "./DistributionConstantsAndFunctions";
import AddWithdrawalAllocation from "./AddWithdrawalAllocation";
import AddedRecipientCard from "./AddedRecipientCard";
import { faPlus, faPlusSquare } from "@fortawesome/pro-regular-svg-icons";
import PeriodicPaymentSourceAllocation from "./PeriodicPaymentSourceAllocation";
import { dummyWithdrawalRequestData } from "./dummyWithdrawalRequestData";
import moment from "moment";

function WithdrawalRequestContainer(props) {
  const { state, dispatch } = useContext(manageDistributionStore);

  const { flow, censusId, withdrawalRequestId, fromPage } = useRouterParams(); //fromPage -1 - from transactions page, 2 - from employee transaction page
  const withdrawal = {};
  const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
  const fields = distributionFormFields[formName];
  const date = new Date();
  const today = new Date(date.setDate(date.getDate()));
  const [selectedPlan, setSelectedPlan] = useState(null);
  const setSelectedPlanInitial = (
    withdrawalRequestData,
    employeePlanWithdrawals
  ) =>
    setSelectedPlan(
      employeePlanWithdrawals?.employeePlans?.findIndex(
        (_) => _.id === withdrawalRequestData.planId
      )
    );
  const [selectPlanError, setSelectPlanError] = useState("");
  const [sliderOpen, setSliderOpen] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);
  const [spousalConsentDocHidden, setSpousalConsentDocHidden] = useState(true);
  const [adoptionCertificateHidden, setAdoptionCertificateHidden] = useState(
    true
  );
  const history = useHistory();
  const [promissoryNoteHidden, setPromissoryNoteHidden] = useState(true);
  const [moreInfoSlideOpen, setMoreInfoSlideOpen] = useState(false);
  const [filteredValues, setFilteredValues] = useState({});
  const [selectModePaymentError, setModePaymentTypeError] = useState("");
  const [responseModel, setResponseModel] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [withdrawalSlider, setWithdrawalSlider] = useState(false);
  const [defaultStateTax, setDefaultStateTax] = useState(0);
  const defaultFederalTax = 20;
  const [responseLoading, setResponseLoading] = useState(false);

  const PrepareFormData = (values, res) => {
    let formData = new FormData();
    if (
      !isEmptyArray(values[fields.spousalConsentFileUpload] ?? []) &&
      !isString(values[fields.spousalConsentFileUpload])
    )
      formData?.append(
        "spousalConsentFileUpload",
        values[fields.spousalConsentFileUpload][0]
      );
    if (
      !isEmptyArray(values[fields.promissoryNoteFileUpload] ?? []) &&
      !isString(values[fields.promissoryNoteFileUpload])
    )
      formData?.append(
        "promissoryNoteFileUpload",
        values[fields.promissoryNoteFileUpload][0]
      );
    if (
      !isEmptyArray(
        values[fields.adoptionOrBirthCertificateFileUpload] ?? []
      ) &&
      !isString(values[fields.adoptionOrBirthCertificateFileUpload])
    )
      formData?.append(
        "adoptionOrBirthCertificateFileUpload",
        values[fields.adoptionOrBirthCertificateFileUpload][0]
      );
    formData?.append(
      "withdrawalRequestId",
      !isEmpty(responseModel) ? responseModel.id : res.withdrawalRequest.id
    );
    return formData;
  };

  useDeepEffect(() => {
    if (!isEmpty(responseModel) && !isEmpty(response))
      setSelectedPlanInitial(responseModel, response);
  }, [responseModel]);

  useDeepEffect(() => {
    //this is for census information
    if (censusId) {
      getEmployeeCensusInformation(parseInt(censusId))
        .then((response) => {
          setFilteredValues(response);
          dispatch(setCensusDataFromAPI(response));
          if (response.stateId !== null)
            getStateTax(response.stateId)
              .then((response) => {
                if (response.isStateWithholdingApplicable)
                  setDefaultStateTax(response.defaultvalue);
              })
              .catch((error) => {
                //Handle Error
              });
        })
        .catch((error) => {});
    }
  }, [censusId]);

  const { response: countries } = useRequest({
    method: getCountriesList,
    defaultResponse: [],
  });

  const { response: stateList } = useRequest({
    method: getStates,
    defaultResponse: [],
  });

  const onFormToggle = () => {
    if (isInnerFormDirty) {
      setShowDirtyCheckModal(true);
    } else {
      setSliderOpen(false);
    }
  };
  const handleConfirmClick = () => {
    setSliderOpen(false);
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };
  const [response, setResponse] = useState({});

  const [
    periodicPaymentCalculationDetails,
    setPeriodicPaymentCalculationDetails,
  ] = useState([]);
  const employeePlanDetails = get(response, `employeePlans.${selectedPlan}`);
  console.log("employeePlanDetails", employeePlanDetails);
  let sourceBalancesFromEmployeePlan = get(
    response,
    `employeePlans.${selectedPlan}.sourceBalances`,
    []
  );
  sourceBalancesFromEmployeePlan = SourceBalancesAfterVestingMultiplier(
    sourceBalancesFromEmployeePlan
  );
  useDeepEffect(() => {
    //employee plan withdrawals
    setResponseLoading(true);
    getEmployeePlanWithdrawals(censusId)
      .then((res) => {
        setResponse(res);
        setResponseLoading(false);
        if (withdrawalRequestId) {
          setResponseLoading(true);
          getWithdrawalRequest(withdrawalRequestId)
            .then((resp) => {
              const selectedPlan_ = res?.employeePlans.findIndex(
                (_) => _.id === resp.planId
              );

              setSelectedPlan(selectedPlan_);
              const tempResponseModel = {
                ...(resp || {}),
                [fields.withdrawalType]: resp.withdrawalType,
                [fields.uploadDocumentThrough]: (
                  resp.uploadDocumentThrough ?? ""
                ).toString(),
                [fields.withdrawalTransactions]: (
                  resp.withdrawalTransactions ?? []
                )?.map((_) => {
                  const sourceBalances_ = get(
                    res,
                    `employeePlans.${selectedPlan_}.sourceBalances`
                  );
                  const filteredSourceBalance_ = getFilteredRkData(
                    sourceBalances_,
                    false,
                    resp,
                    _,
                    0
                  );
                  const grossAmountInitial = calculateGrossAmountFromNetAmountSourceWise(
                    _,
                    resp,
                    filteredSourceBalance_
                  );
                  const effectiveWithdrawalTransaction = {
                    ..._,
                    [fields.grossAmount]: grossAmountInitial,
                  };
                  const netAmountInitial = calculateRequestedAmountEffective(
                    resp,
                    effectiveWithdrawalTransaction,
                    filteredSourceBalance_
                  );
                  return {
                    ...effectiveWithdrawalTransaction,
                    [fields.taxesAndFees]:
                      grossAmountInitial - netAmountInitial,
                  };
                }),
                spousalConsentFileUpload: resp?.spousalConsentFileUpload || [],
                promissoryNoteFileUpload: resp?.promissoryNoteFileUpload || [],
                adoptionOrBirthCertificateFileUpload:
                  resp?.adoptionOrBirthCertificateFileUpload || [],
              };
              setResponseModel(tempResponseModel);
              // if (!isEmpty(response))
              //   setSelectedPlanInitial(resp, response)
              setResponseLoading(false);
            })
            .catch((ex) => {
              setResponseLoading(false);
            });
        } else {
          setSelectedPlan(0);
        }
      })
      .catch((ex) => setResponseLoading(false));
  }, []);

  useDeepEffect(() => {
    /// fetching periodic payment data
    if (selectedPlan !== null)
      getPeriodicPaymentCalculationDetails(
        employeePlans[selectedPlan].id,
        censusId
      ).then((res) => {
        if (res.isSuccessfull)
          setPeriodicPaymentCalculationDetails(
            res.periodicPaymentDetails ?? []
          );
      });
  }, [selectedPlan, censusId]);

  const employeePlans = response?.employeePlans ?? [];

  const initialValues = {
    WithdrawalStatus: 1,
    planName: get(employeePlans, `${selectedPlan}.planName`),
    planId: get(employeePlans, `${selectedPlan}.id`),
    [fields.modeOfPayment]: 1,
    [fields.signedThroughDocusign]: false,
    ...responseModel,
    ...response,
  };

  const translateRequest = (values, mode) => {
    let y = values?.withdrawalTransactions?.map((item, ind) => {
      let z = {
        id: item.id,
        sortOrder: ind,
        code: item.code,
        distributionMode: item.distributionMode,
        paymentMethod: item.paymentMethod,
        requestedAmount: item.requestedAmount,
        grossAmount: item.grossAmount,
        typeOfAddressOrBankDetails: item.selectAddressDetails
          ? item.selectAddressDetails
          : item.selectBankDetails,
        checkFee: item.checkFee,
        eftFee: item.eftFee,
        stateTax: item.stateTax,
        federalTax: item.federalTax,
        rollOverFee: item.rollOverFee,
        // recurringFee: item.recurringFee,
        waiveOffLimitApplicable: item.waiveOffLimitApplicable,
        waiveOffLimit: item.waiveOffLimit,
        waiveOffLimitReason: item.waiveOffLimitReason,
        earlyWithdrawalPenalty: item.earlyWithdrawalPenalty,
        // withdrawalRequestId:
        iraNumber: item.iraNumber,
        //nameOfTheFinancialInstitution:
        planName: item.planName,
        trusteeName: item.trusteeName,
        // planId:
        beneficiaryId: item.beneficiaryId,
        address: { ...item.address, id: 0 },
        bankInformation: { ...item.bankInformation, id: 0 },
        allocatedSourceWithdrawal: item.allocatedSourceWithdrawal,
        sourceAllocationCalculationMethod:
          item.sourceAllocationCalculationMethod,
        customizeAllocationCalculationMethod:
          item.customizeAllocationCalculationMethod,
        hierarchyCalculationMethod: item.hierarchyCalculationMethod,
        sourceHierarchyDetails: get(item, "sourceHierarchyDetails", []).map(
          (_) => {
            return {
              id: _.id ?? 0,
              sourceId: _.sourceId,
              hierarchyNumber: _.hierarchyNumber,
              investmentHierarchies: get(_, "investmentHierarchies", []).map(
                (inv) => {
                  return {
                    id: inv.id ?? 0,
                    investmentId: inv.investmentId,
                    hierarchyNumber: inv.hierarchyNumber,
                  };
                }
              ),
            };
          }
        ),
        // sourceWithdrawal:[] this is not needed to be deleted in backend
      };
      return z;
    });
    const today = new Date();
    let x = {
      //approveWithdrawalRequests : []
      id: withdrawalRequestId ? withdrawalRequestId : 0,
      employeeId: parseInt(censusId),
      modeOfPayment: values[fields.modeOfPayment],
      signedThroughDocusign: get(values, "signedThroughDocusign", false),
      planId: employeePlans[selectedPlan].id,
      withdrawalId: values[fields.withdrawalId], // -- input
      withdrawalType: values[fields.withdrawalType],
      withdrawEntireAmount: values[fields.withdrawEntireAmount],
      withdrawalFee: values[fields.withdrawalFee],
      netAmountRequested: values[fields.netAmountRequested],
      userId: 1, // -- input
      withdrawalStatus: parseInt(fromPage) === 1 ? 2 : 1, // -- input
      requestDate: moment().format(),
      isDraft: mode,
      // Periodic Payment -
      periodicPaymentType: values[fields.periodicPaymentType],
      netPeriodicPaymentAmount: values[fields.netPeriodicPaymentAmount],
      typeOfExpectancy: values[fields.typeOfExpectancy],
      dateOfAnnuityPayments: values[fields.dateOfAnnuityPayments],
      frequency: values[fields.frequency],
      nextRepaymentDate: values[fields.nextRepaymentDate],
      numberOfInstallments: values[fields.numberOfInstallments],
      // withdrawalAmountPerFrequency :
      withdrawalTransactions: y,
      spousalConsentFileUpload: isString(
        values[fields.spousalConsentFileUpload]
      )
        ? values[fields.spousalConsentFileUpload]
        : null,
      promissoryNoteFileUpload: isString(
        values[fields.promissoryNoteFileUpload]
      )
        ? values[fields.promissoryNoteFileUpload]
        : null,
      adoptionOrBirthCertificateFileUpload: isString(
        values[fields.adoptionOrBirthCertificateFileUpload]
      )
        ? values[fields.adoptionOrBirthCertificateFileUpload]
        : null,
    };
    return { ...x };
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting, setErrors }
  ) => {
    let tempErrorList = {};
    if (isEmpty(get(values, fields.withdrawalTransactions, [])))
      tempErrorList[fields.withdrawalTransactions] = "Required";
    if (isQBAD(values) && !values[fields.adoptionOrBirthCertificateFileUpload])
      tempErrorList[fields.adoptionOrBirthCertificateFileUpload] = "Required";

    if (isEmpty(tempErrorList)) {
      setResponseLoading(true);
      saveRequest(translateRequest(values, false), dispatch)
        .then((res) => {
          setResponseLoading(false);
          if (res.isSuccessful) {
            if (
              !isEmpty(values[fields.spousalConsentFileUpload]) ||
              !isEmpty(values[fields.promissoryNoteFileUpload]) ||
              !isEmpty(values[fields.adoptionOrBirthCertificateFileUpload])
            ) {
              setResponseLoading(true);

              var formData = PrepareFormData(values, res);
              uploadWithdrawalDocuments(formData, dispatch)
                .then((res) => {
                  dispatch(
                    setManageDistributionToastInfo({
                      showToast: true,
                      toastMessage: "Data saved successfully",
                    })
                  );

                  dispatch(
                    setWithdrawalRequestPageData({
                      formName: "withdrawalRequestData",
                      fieldData: res?.withdrawalRequest,
                    })
                  );
                  dispatch(
                    setWithdrawalRequestPageData({
                      formName: "employeePlansWithdrawal",
                      fieldData: response,
                    })
                  );
                  setResponseLoading(false);
                  history.push(
                    getPathWithParam({
                      path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                      pathParam: [
                        flow,
                        censusId,
                        res?.withdrawalRequest?.id,
                        1,
                      ],
                    })
                  );
                })
                .catch((error) => {
                  setResponseLoading(false);
                  dispatch({
                    type: MANAGE_DISTRIBUTION_POST_API_ERROR,
                    payload: error,
                  });
                });
            } else {
              setResponseLoading(false);
              dispatch(
                setManageDistributionToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
              fromPage == 1
                ? history.push(
                    getPathWithParam({
                      path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWALAPPROVAL}`,
                      pathParam: [
                        flow,
                        censusId,
                        withdrawalRequestId,
                        fromPage,
                      ],
                    })
                  )
                : history.push(
                    getPathWithParam({
                      path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                      pathParam: [
                        flow,
                        censusId,
                        res?.withdrawalRequest?.id,
                        1,
                      ],
                    })
                  );
            }
          } else {
            if (
              withdrawal?.spouseConsentRequired &&
              isEmptyArray(values[fields.spousalConsentFileUpload])
            ) {
              //setIsUploadSuccess(false);
              dispatch({
                type: MANAGE_DISTRIBUTION_POST_API_ERROR,
                payload: "error",
              });
            }
            setResponseLoading(false);
            setSubmitting(false);
            for (var i = 0; i < res.errorMessages?.length; i++) {
              var _ = res.errorMessages[i];
              setFieldTouched(_.controlName, true);
              setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            }
          }
        })
        .catch((error) => {
          setResponseLoading(false);
        });
    }
    setErrors(tempErrorList);
  };

  return (
    <LoaderWrapper isLoading={responseLoading} loaderText="">
      <Formik
        initialValues={{
          ...initialValues,
        }}
        enableReinitialize
        onSubmit={onFormSubmit}
        validateOnChange={false}
        // validationSchema={validationSchema}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            errors,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          const sourceBalances = DeductProratedSplits(
            sourceBalancesFromEmployeePlan,
            CalculateProrationSplitUp(
              sourceBalancesFromEmployeePlan,
              values[fields.withdrawalFee],
              [],
              false
            ),
            isPartialWithdrawal(values) ? 0.9 : 1
          );
          console.log("outer-values", values);

          const selectedWithdrawalPlanSetUp = get(
            response,
            `employeePlans.${selectedPlan}.withdrawals`,
            []
          ).find((_) => _.id === values[fields.withdrawalId]);

          const buttons =
            fromPage === "1"
              ? [
                  {
                    //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                    link: getPathWithParam({
                      path: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
                    }),
                    label: "Cancel",
                    variant: "secondary",
                    type: "button",
                    //flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
                  },
                  {
                    label: "Next",
                    variant: "primary",
                    type: "submit",
                    // link: getPathWithParam({
                    //   path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                    //   pathParam: [flow, censusId, withdrawalRequestId],
                    // }),
                  },
                ]
              : [
                  {
                    //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                    label: "save as draft",
                    variant: "secondary",
                    type: "button",
                    onClick: () => {
                      if (
                        values.planId &&
                        values.withdrawalType &&
                        values.modeOfPayment
                      ) {
                        setSelectPlanError(" ");
                        setModePaymentTypeError(" ");
                        setResponseLoading(true);
                        saveRequest(translateRequest(values, true), dispatch)
                          .then((response) => {
                            setResponseLoading(false);
                            if (response.isSuccessful) {
                              var formData = PrepareFormData(values, response);
                              uploadWithdrawalDocuments(formData, dispatch)
                                .then((res) => {
                                  dispatch(
                                    setManageDistributionToastInfo({
                                      showToast: true,
                                      toastMessage: "Data saved successfully",
                                    })
                                  );
                                  setSubmitting(true);
                                  history.push(
                                    // fromPage == 4
                                    //   ? getPathWithParam({
                                    //       path: MANAGE_TRANSACTION_ROUTES.DRAFT,
                                    //     }) :
                                    getPathWithParam({
                                      path:
                                        MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                                      pathParam: [flow, censusId],
                                    })
                                  );
                                })
                                .catch((error) => {
                                  dispatch({
                                    type: MANAGE_DISTRIBUTION_POST_API_ERROR,
                                    payload: error,
                                  });
                                });
                            }
                          })
                          .catch((ex) => setResponseLoading(false));
                      } else {
                        setFieldError(
                          fields.withdrawalName,
                          "WL001 : Required"
                        );
                        {
                          values.planId && setSelectPlanError(" ");
                        }
                        {
                          values.withdrawalType && (
                            <div>
                              {!values.modeOfPayment &&
                                setModePaymentTypeError("* RI026 : Required ")}
                            </div>
                          );
                        }
                        {
                          values.modeOfPayment && setModePaymentTypeError(" ");
                        }
                      }
                    },
                  },
                  {
                    //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                    link: getAdvancedPathWithParam({
                      path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                      pathParam: [FLOW_TYPES.EDIT, censusId],
                    }),
                    label: "Cancel",
                    variant: "secondary",
                    type: "button",
                    //flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
                  },
                  {
                    label: "Next",
                    variant: "primary",
                    type: "submit",
                    // link: getPathWithParam({
                    //   path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                    //   pathParam: [flow, censusId, withdrawalRequestId],
                    // }),
                  },
                ];

          const withdrawalTransactionForPeriodicPayment = get(
            values,
            "withdrawalTransactions.0",
            {}
          );

          const navigateToWithdrawalAllocation = async () => {
            setSelectedIndex(null);
            setWithdrawalSlider(true);
            // await setSubmitting(true);
            // dispatch(cacheWithdrawalRequestPageLevelData(values));
            // history.push(
            //   getAdvancedPathWithParam({
            //     path: MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_ALLOCATION,
            //     pathParam: [FLOW_TYPES.EDIT, censusId],
            //   })
            // );
            // setWithdrawalSlider(true);
          };
          const vestBalance = calculateTotalVestedBalanceFromSourceBalance(
            get(employeePlans, `${selectedPlan}.sourceBalances`, [])
          );

          const specificTenureData = periodicPaymentCalculationDetails.find(
            (_) =>
              _.periodicPaymentType == "SpecificTenure" &&
              ([null, undefined].includes(values[fields.typeOfExpectancy]) ||
                values[fields.typeOfExpectancy] === _.lifeExpectancyType) &&
              ([null, undefined].includes(values[fields.frequency]) ||
                values[fields.frequency] === _.frequencyType)
          );
          const annuitizationData = periodicPaymentCalculationDetails.find(
            (_) =>
              _.periodicPaymentType == "Annuitization" &&
              ([null, undefined].includes(values[fields.typeOfExpectancy]) ||
                values[fields.typeOfExpectancy] === _.lifeExpectancyType) &&
              ([null, undefined].includes(values[fields.frequency]) ||
                values[fields.frequency] === _.frequencyType)
          );
          console.log("annuitizationData", annuitizationData);
          const withdrawalAmountForSpecificTenure =
            specificTenureData?.grossAmount ??
            vestBalance / get(values, fields.numberOfInstallments) ??
            1;

          const calculateMaximumWithDrawalAmount = (values) =>
            get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
              (_) => _.id === values[fields.withdrawalId]
            )?.maximumWithDrawalLimitAmount !== null &&
            get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
              (_) => _.id === values[fields.withdrawalId]
            )?.maximumWithDrawalLimitAmount < vestBalance
              ? get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
                  (_) => _.id === values[fields.withdrawalId]
                )?.maximumWithDrawalLimitAmount
              : values.withdrawEntireAmount == false
              ? ((90 * vestBalance) / 100).toFixed(2)
              : vestBalance.toFixed(2);

          const maximumWithDrawalAmount = calculateMaximumWithDrawalAmount(
            values
          );

          const minimumWithDrawalAmount =
            get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
              (_) => _.id === values[fields.withdrawalId]
            )?.minimumWithDrawalLimitAmount === null
              ? 0
              : get(employeePlans, `${selectedPlan}.withdrawals`, []).find(
                  (_) => _.id === values[fields.withdrawalId]
                )?.minimumWithDrawalLimitAmount;

          const periodicPaymentFrequency =
            values[fields.dateOfAnnuityPayments] === 1
              ? selectedWithdrawalPlanSetUp?.paymentFrequencyApplicable
              : values[fields.frequency];

          const periodicPaymentDataSelected = (
            periodicPaymentCalculationDetails ?? []
          ).find(
            (_) =>
              _.periodicPaymentType == getPeriodicPaymentType(values) &&
              ([null, undefined].includes(values[fields.typeOfExpectancy]) ||
                values[fields.typeOfExpectancy] === _.lifeExpectancyType) &&
              ([null, undefined].includes(periodicPaymentFrequency) ||
                periodicPaymentFrequency === _.frequencyType)
          );

          const selectedWithdrawalTransactionData = get(
            values,
            `withdrawalTransactions.${selectedIndex}`,
            {}
          );

          return (
            <Form onSubmit={handleSubmit} validated={!isEmpty(rest.errors)}>
              <ManageDistributionLayoutNew
                isWithdrawalRequest={true}
                setSelectPlanError={setSelectPlanError}
                buttons={buttons}
                layoutHeader="New Withdrawal Request"
                values={values}
                censusId={censusId}
                withdrawalRequestId={withdrawalRequestId}
                planId={values.planId}
                withdrawalId={withdrawal && withdrawal?.id}
              >
                <div className="d-flex">
                  <div style={{ width: "95%" }}>
                    <div className="m-3 withdrawal-request-contrainer-new margin-bottom-4rem">
                      <div className="heading-div">Employee Details</div>
                      <EmployeeDetailsCard
                        setMoreInfoSlideOpen={setMoreInfoSlideOpen}
                        filteredValues={filteredValues}
                      />

                      <div className="overflow-Y">
                        <p className=" ft-16 fw-500 heading_color mt-30">
                          Select Plan
                        </p>
                        <div className="d-flex flex-row">
                          <FontAwesomeIcon
                            className="fw-300 ft-14 Dark-Grey-Color mr-1"
                            icon={faExclamationCircle}
                          />
                          <p className="fw-400 ft-12 ">
                            The available amount is reported as of{" "}
                            <span className="fw-500 ">
                              {usDateFormat(today)}
                            </span>{" "}
                            and may change due to market fluctuations.
                          </p>
                        </div>
                        <p className="rollOverErrorStyle">{selectPlanError}</p>
                        <PlanCards
                          {...formProps}
                          plans={employeePlans}
                          fields={fields}
                          selectedPlan={selectedPlan}
                          setSelectedPlan={setSelectedPlan}
                        />
                      </div>
                      {selectedPlan !== null && (
                        <>
                          <BasicDetailsCard
                            {...formProps}
                            fields={fields}
                            values={values}
                            style={{}}
                            employeePlans={employeePlans}
                            selectedPlan={selectedPlan}
                            setValues={setValues}
                            setFieldValue={setFieldValue}
                            selectModePaymentError={selectModePaymentError}
                            max={maximumWithDrawalAmount}
                            min={minimumWithDrawalAmount}
                            selectedWithdrawalPlanSetUp={
                              selectedWithdrawalPlanSetUp
                            }
                            initialValues={initialValues}
                            calculateMaximumWithDrawalAmount={
                              calculateMaximumWithDrawalAmount
                            }
                          />
                          {values[fields.periodicPaymentType] && (
                            <>
                              {(values[fields.periodicPaymentType] ===
                                OPTIONS_DATA_MAPPER
                                  .PERIODIC_PAYMENT_OPTIONS_ENUM
                                  .AnnuitizationMethod ||
                                values[fields.periodicPaymentType] ===
                                  OPTIONS_DATA_MAPPER
                                    .PERIODIC_PAYMENT_OPTIONS_ENUM
                                    .SpecificDollar) && (
                                <AnnutizationDetails
                                  {...formProps}
                                  fields={fields}
                                  values={values}
                                  vestBalance={vestBalance}
                                  periodicPaymentCalculationDetails={
                                    periodicPaymentCalculationDetails
                                  }
                                  employeeDetails={filteredValues}
                                  selectedWithdrawalPlanSetUp={
                                    selectedWithdrawalPlanSetUp
                                  }
                                  employeePlans={employeePlans}
                                  selectedPlan={selectedPlan}
                                  className="mt_Head"
                                />
                              )}
                              {values[fields.periodicPaymentType] ===
                                OPTIONS_DATA_MAPPER
                                  .PERIODIC_PAYMENT_OPTIONS_ENUM
                                  .SpecificTenure && (
                                <SpecificTenureDetails
                                  {...formProps}
                                  fields={fields}
                                  values={values}
                                  vestBalance={vestBalance}
                                  employeeDetails={filteredValues}
                                  periodicPaymentCalculationDetails={
                                    periodicPaymentCalculationDetails
                                  }
                                  className="mt_Head"
                                  selectedWithdrawalPlanSetUp={
                                    selectedWithdrawalPlanSetUp
                                  }
                                  withdrawalAmountForSpecificTenure={
                                    withdrawalAmountForSpecificTenure
                                  }
                                  specificTenureData={specificTenureData}
                                />
                              )}
                            </>
                          )}
                          <>
                            {/* Withdrawal allocation sub part */}
                            {values?.withdrawalType &&
                              (values[fields.modeOfPayment] !== 2 ||
                                ![null, undefined, ""].includes(
                                  values[fields.periodicPaymentType]
                                )) && (
                                <>
                                  <div className="d-flex w-100 mt-5">
                                    <div className="heading-div mb-3">
                                      Withdrawal Allocation
                                    </div>
                                    {get(values, "withdrawalTransactions", [])
                                      .length !== 0 &&
                                      get(values, fields.modeOfPayment) ===
                                        1 && (
                                        <div
                                          className="d-flex  light-blue cursor-pointer ml-auto align-items-center"
                                          onClick={
                                            navigateToWithdrawalAllocation
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={faPlusSquare}
                                            className="ft-14 fw-300 cursor-pointer mr-2"
                                          />{" "}
                                          Add
                                        </div>
                                      )}
                                    {values[fields.modeOfPayment] === 2 &&
                                      get(values, "withdrawalTransactions", [])
                                        .length !== 0 && (
                                        <div
                                          className="d-flex  light-blue cursor-pointer ml-auto align-items-center"
                                          onClick={() => {
                                            setSelectedIndex(0);
                                            setWithdrawalSlider(true);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faEdit}
                                            className="ft-14 fw-300  mr-2"
                                          />
                                          Edit
                                        </div>
                                      )}
                                  </div>
                                  {get(values, "withdrawalTransactions", [])
                                    .length === 0 && (
                                    <>
                                      <ConfigureCommunicationField
                                        className="primary-small primary-small-border"
                                        data="Add withdrawal allocation"
                                        isCommunication={false}
                                        onClickNavigate={
                                          navigateToWithdrawalAllocation
                                        }
                                        style={{
                                          backgroundColor: "rgba(0,77,203,0.1)",
                                          width: "100%",
                                          padding: "10px",
                                          borderRadius: "5px",
                                        }}
                                      />
                                      <div style={{ color: "#ff5050" }}>
                                        {errors[fields.withdrawalTransactions]}
                                      </div>
                                    </>
                                  )}

                                  <AddedRecipientCard
                                    setSelectedIndex={setSelectedIndex}
                                    fields={fields}
                                    {...formProps}
                                    setWithdrawalSlider={setWithdrawalSlider}
                                    employeeData={filteredValues}
                                    withdrawalRequestData={values}
                                  />

                                  <div
                                    className="upload-documents"
                                    style={{ marginTop: "2rem" }}
                                  >
                                    <div>
                                      <input
                                        type="radio"
                                        id={uploadDocumentThrough[0]}
                                        name={"radioButton"}
                                        value="0"
                                        checked={
                                          values.signedThroughDocusign == false
                                        }
                                        onChange={(e) =>
                                          setFieldValue(
                                            fields.signedThroughDocusign,
                                            false
                                          )
                                        }
                                      />
                                      <label for="html">
                                        Upload the signed documents
                                      </label>

                                      <input
                                        style={{ marginLeft: "20px" }}
                                        type="radio"
                                        id={uploadDocumentThrough[1]}
                                        name={"radioButton"}
                                        value="1"
                                        checked={
                                          values.signedThroughDocusign == true
                                        }
                                        onChange={(e) =>
                                          setFieldValue(
                                            fields.signedThroughDocusign,
                                            true
                                          )
                                        }
                                      />
                                      <label for="html">
                                        Sign the document through DocuSign
                                      </label>
                                    </div>
                                    {!values.signedThroughDocusign && (
                                      <div>
                                        <p className="heading-div mb-0 mt-3">
                                          Upload Documents
                                        </p>

                                        {filteredValues?.maritalStatus == "M" &&
                                          selectedWithdrawalPlanSetUp?.spouseConsentRequired && (
                                            <>
                                              {" "}
                                              <div className="W-100 d-flex flex-row">
                                                <div className="W-50 px-50-30 Border-Solid Border-None-right H-142 mt-25">
                                                  <p className="fw-600 ft-14 Black m-0">
                                                    Spousal Consent
                                                    {withdrawal?.spouseConsentRequired
                                                      ? " (required)"
                                                      : " (Optional)"}
                                                  </p>
                                                  <div className="d-flex flex-row justify-content-between">
                                                    <p
                                                      className="fw-400 ft-12 Grey-Color m-0 mr-10"
                                                      style={{ width: "180px" }}
                                                    >
                                                      Accepted file : pdf, word,
                                                      txt, jpg, jpeg, excel,
                                                      png, csv
                                                    </p>
                                                    <p className="fw-400 ft-12 Grey-Color m-0">
                                                      Max File Size: 2 MB
                                                    </p>
                                                  </div>
                                                </div>{" "}
                                                <div className="W-50">
                                                  <UploadComponentWithDrawalSpousal
                                                    // isUploadSuccess={isUploadSuccess}
                                                    setFieldValue={
                                                      setFieldValue
                                                    }
                                                    enablePreview={true}
                                                    name={
                                                      fields.spousalConsentFileUpload
                                                    }
                                                    fileExtensions=".jpeg, .png, .jpg, .pdf"
                                                    values={values}
                                                    responseModel={
                                                      responseModel
                                                    }
                                                    documentHidden={
                                                      spousalConsentDocHidden
                                                    }
                                                    setDocumentHidden={
                                                      setSpousalConsentDocHidden
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div>
                                                {values[
                                                  fields
                                                    .spousalConsentFileUpload
                                                ] &&
                                                  !spousalConsentDocHidden && (
                                                    <ContentPreviewer
                                                      data={
                                                        !isEmptyArray(
                                                          values[
                                                            fields
                                                              .spousalConsentFileUpload
                                                          ]
                                                        )
                                                          ? URL.createObjectURL(
                                                              values[
                                                                fields
                                                                  .spousalConsentFileUpload
                                                              ][0]
                                                            )
                                                          : null
                                                      }
                                                    />
                                                  )}
                                              </div>
                                            </>
                                          )}

                                        <div className="W-100 d-flex flex-row">
                                          <div
                                            style={{
                                              width: "50%",
                                              padding: "40px 10px 0px 30px",
                                              border: "0.5px solid #BDBDBD",
                                              borderRight: "none",
                                              height: "142px",
                                              marginTop: "25px",
                                            }}
                                          >
                                            <p className="fw-600 ft-14 Black m-0 mb-3">
                                              Promissory Note
                                            </p>
                                            <div className="d-flex flex-row justify-content-between">
                                              <p
                                                className="fw-400 ft-12 Grey-Color m-0 mr-10"
                                                style={{ width: "180px" }}
                                              >
                                                Accepted file : pdf, word, txt,
                                                jpg, jpeg, excel, png, csv
                                              </p>
                                              <p className="fw-400 ft-12 Grey-Color m-0">
                                                Max File Size: 2 MB
                                              </p>
                                            </div>
                                          </div>
                                          <div className="W-50">
                                            <UploadComponentLoans
                                              // isUploadSuccess={true}
                                              setFieldValue={setFieldValue}
                                              enablePreview={true}
                                              name={
                                                fields.promissoryNoteFileUpload
                                              }
                                              // fieldName={
                                              //   fields.promissoryNoteFileUpload
                                              // }
                                              fileExtensions=".jpeg, .png, .jpg, .pdf"
                                              values={values}
                                              documentHidden={
                                                promissoryNoteHidden
                                              }
                                              setDocumentHidden={
                                                setPromissoryNoteHidden
                                              }
                                              responseModel={responseModel}
                                            />
                                          </div>
                                        </div>

                                        <div>
                                          {values[
                                            fields.promissoryNoteFileUpload
                                          ] &&
                                            !promissoryNoteHidden && (
                                              <ContentPreviewer
                                                data={
                                                  !isEmptyArray(
                                                    values[
                                                      fields
                                                        .promissoryNoteFileUpload
                                                    ]
                                                  )
                                                    ? URL.createObjectURL(
                                                        values[
                                                          fields
                                                            .promissoryNoteFileUpload
                                                        ][0]
                                                      )
                                                    : null
                                                }
                                              />
                                            )}
                                        </div>

                                        {values[fields.withdrawalType] ===
                                          withdrawalTypeEnum.QBAD && (
                                          <>
                                            {" "}
                                            <div className="W-100 d-flex flex-row">
                                              <div className="W-50 px-50-30 Border-Solid Border-None-right H-142 mt-25">
                                                <p className="fw-600 ft-14 Black m-0">
                                                  Adoption or Birth Certificate
                                                  (required)
                                                </p>
                                                <div className="d-flex flex-row justify-content-between">
                                                  <p
                                                    className="fw-400 ft-12 Grey-Color m-0 mr-10"
                                                    style={{ width: "180px" }}
                                                  >
                                                    Accepted file : pdf, word,
                                                    txt, jpg, jpeg, excel, png,
                                                    csv
                                                  </p>
                                                  <p className="fw-400 ft-12 Grey-Color m-0">
                                                    Max File Size: 2 MB
                                                  </p>
                                                </div>
                                              </div>{" "}
                                              <div className="W-50">
                                                <UploadComponentWithDrawalSpousal
                                                  // isUploadSuccess={isUploadSuccess}
                                                  setFieldValue={setFieldValue}
                                                  enablePreview={true}
                                                  name={
                                                    fields.adoptionOrBirthCertificateFileUpload
                                                  }
                                                  fileExtensions=".jpeg, .png, .jpg, .pdf"
                                                  values={values}
                                                  responseModel={responseModel}
                                                  documentHidden={
                                                    adoptionCertificateHidden
                                                  }
                                                  setDocumentHidden={
                                                    setAdoptionCertificateHidden
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div style={{ color: "#ff5050" }}>
                                              {
                                                errors[
                                                  fields
                                                    .adoptionOrBirthCertificateFileUpload
                                                ]
                                              }
                                            </div>
                                            <div>
                                              {values[
                                                fields
                                                  .adoptionOrBirthCertificateFileUpload
                                              ] &&
                                                !adoptionCertificateHidden && (
                                                  <ContentPreviewer
                                                    data={
                                                      !isEmptyArray(
                                                        values[
                                                          fields
                                                            .adoptionOrBirthCertificateFileUpload
                                                        ]
                                                      )
                                                        ? URL.createObjectURL(
                                                            values[
                                                              fields
                                                                .adoptionOrBirthCertificateFileUpload
                                                            ][0]
                                                          )
                                                        : null
                                                    }
                                                  />
                                                )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <SliderPanel
                                    isOpen={withdrawalSlider}
                                    size="80"
                                    showCancel={false}
                                    showBackButton={false}
                                    backdropClicked={() => {
                                      setWithdrawalSlider(false);
                                    }}
                                  >
                                    <AddWithdrawalAllocation
                                      selectedIndex={selectedIndex}
                                      employeePlanDetails={employeePlanDetails}
                                      setSelectedIndex={setSelectedIndex}
                                      filteredValues={filteredValues}
                                      initialValues={
                                        selectedIndex !== null
                                          ? {
                                              ...selectedWithdrawalTransactionData,
                                              [fields.requestedAmount]: calculationToBeBasedOnGrossAmount(
                                                values
                                              )
                                                ? null
                                                : selectedWithdrawalTransactionData[
                                                    fields.requestedAmount
                                                  ],
                                              [fields.grossAmount]: calculationToBeBasedOnGrossAmount(
                                                values
                                              )
                                                ? selectedWithdrawalTransactionData[
                                                    fields.requestedAmount
                                                  ]
                                                : null,
                                            }
                                          : {}
                                      }
                                      fields={fields}
                                      outerValues={values}
                                      outerSetValues={setValues}
                                      onDeleteAllocation={() => {
                                        const filteredTransactions = get(
                                          values,
                                          "withdrawalTransactions",
                                          []
                                        ).filter(
                                          (_, ind) => ind !== selectedIndex
                                        );
                                        setFieldValue(
                                          "withdrawalTransactions",
                                          filteredTransactions
                                        );
                                        setWithdrawalSlider(false);
                                      }}
                                      countries={countries}
                                      stateList={stateList}
                                      setWithdrawalSlider={setWithdrawalSlider}
                                      withdrawalSlider={withdrawalSlider}
                                      sourceBalances={sourceBalances}
                                      maximumWithDrawalAmount={
                                        maximumWithDrawalAmount
                                      }
                                      setSliderOpen={setSliderOpen}
                                      setShowDirtyCheckModal={
                                        setShowDirtyCheckModal
                                      }
                                      setIsInnerFormDirty={setIsInnerFormDirty}
                                      employeePlans={employeePlans}
                                      selectedPlan={selectedPlan}
                                      showDirtyCheckModal={showDirtyCheckModal}
                                      handleConfirmClick={handleConfirmClick}
                                      handleCancelClick={handleCancelClick}
                                      onFormToggle={onFormToggle}
                                      isInnerFormDirty={isInnerFormDirty}
                                      sliderOpen={sliderOpen}
                                      values={values}
                                      selectedWithdrawalPlanSetUp={
                                        selectedWithdrawalPlanSetUp
                                      }
                                      defaultStateTax={defaultStateTax}
                                      defaultFederalTax={defaultFederalTax}
                                      withdrawalAmountForPeriodicPaymentTransaction={
                                        isSpecificDollar(values)
                                          ? values[
                                              fields.netPeriodicPaymentAmount
                                            ]
                                          : isSpecificTenure(values)
                                          ? withdrawalAmountForSpecificTenure
                                          : annuitizationData?.grossAmount
                                      }
                                    />
                                  </SliderPanel>
                                </>
                              )}
                            {!isEmpty(values?.withdrawalTransactions) && (
                              <>
                                {values[fields.modeOfPayment] === 2 &&
                                  withdrawalTransactionForPeriodicPayment && (
                                    <>
                                      <div className="d-flex w-100 mt-5">
                                        <div className="heading-div mb-3">
                                          Source Allocation
                                        </div>
                                      </div>

                                      <div className="ft-12">
                                        {get(
                                          withdrawalTransactionForPeriodicPayment,
                                          fields.sourceAllocationCalculationMethod
                                        ) === 1
                                          ? "Prorata"
                                          : "Hierarchy"}
                                      </div>
                                      <PeriodicPaymentSourceAllocation
                                        values={values}
                                        withdrawalTransactionForPeriodicPayment={
                                          withdrawalTransactionForPeriodicPayment
                                        }
                                        sourceBalances={sourceBalances}
                                      />
                                    </>
                                  )}

                                {values[fields.modeOfPayment] === 2 && (
                                  <>
                                    <div className="heading-div mt-5">
                                      Payment Schedule
                                    </div>
                                    <div
                                      style={{ color: "#919191" }}
                                      className="d-flex flex-row"
                                    >
                                      <FontAwesomeIcon
                                        className="fw-300 ft-14 mr-1"
                                        icon={faExclamationCircle}
                                      />
                                      <p className="fw-400 ft-12 ">
                                        The generated payment schedule is
                                        tentative in nature & subjected to
                                        changes due to market fluctuations
                                      </p>
                                    </div>
                                    <div className="ft-14">
                                      {
                                        OPTIONS_DATA_MAPPER
                                          .PAYROLLFREQUENCY_TYPE[
                                          periodicPaymentFrequency
                                        ]
                                      }{" "}
                                      frequency
                                    </div>
                                    <PaymentScheduleTable
                                      fields={fields}
                                      values={values}
                                      selectedWithdrawalPlanSetUp={
                                        selectedWithdrawalPlanSetUp
                                      }
                                      periodicPaymentDataSelected={
                                        periodicPaymentDataSelected
                                      }
                                      withdrawalTransactionForPeriodicPayment={
                                        withdrawalTransactionForPeriodicPayment
                                      }
                                      withdrawalRequestData={values}
                                      sourceBalances={sourceBalances}
                                      periodicPaymentFrequency={
                                        periodicPaymentFrequency
                                      }
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </>
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "30%",
                      borderLeft: "1px solid rgb(189, 189, 189)",
                    }}
                  >
                    <div>
                      <div className="summaryCard_Heading">
                        {" "}
                        Request Summary
                      </div>
                      <div className="summaryCard_HeaderLine"></div>

                      <div className="summaryCard_DetailsHeader">
                        Selected Plan
                      </div>
                      <div className="summaryCard_DetailsBody">
                        {values[fields.planName]}
                      </div>

                      {values[fields.withdrawalName] && (
                        <div>
                          <div>
                            <div className="summaryCard_DetailsHeader">
                              Withdrawal Type
                            </div>
                            <div className="summaryCard_DetailsBody">
                              {values[fields.withdrawalName]}
                            </div>
                          </div>

                          {values[fields.modeOfPayment] && (
                            <div>
                              {values[fields.withdrawEntireAmount] === true ? (
                                <div className="summaryCard_DetailsHeader">
                                  Requested Amount (Full)
                                </div>
                              ) : (
                                <div className="summaryCard_DetailsHeader">
                                  Requested Amount (Partial)
                                </div>
                              )}

                              <div className="d-flex">
                                {values[fields.modeOfPayment] === 1 ? (
                                  <div className="summaryCard_DetailsBody">
                                    One Time Payment
                                  </div>
                                ) : (
                                  <div className="summaryCard_DetailsBody">
                                    Periodic Payment
                                  </div>
                                )}

                                <div
                                  className="summaryCard_DetailsBody"
                                  style={{
                                    marginLeft: "auto",
                                    marginRight: "30px",
                                  }}
                                >
                                  $ {values[fields.netAmountRequested]}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {!isEmpty(values[fields.withdrawalTransactions]) && (
                        <>
                          <div
                            className="summaryCard_DetailsHeader"
                            style={{ fontSize: "15px" }}
                          >
                            Withdrawal Allocation
                          </div>

                          <RequestSummaryCard
                            values={values}
                            employeeData={filteredValues}
                            fields={fields}
                            beneficiaries={response?.beneficiaries}
                            sourceBalances={sourceBalances}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </ManageDistributionLayoutNew>
            </Form>
          );
        }}
      </Formik>
      <SliderPanel
        isOpen={moreInfoSlideOpen}
        size="80"
        showCancel={false}
        backdropClicked={() => setMoreInfoSlideOpen(false)}
      >
        <EmployeeSliderDetails
          fields={fields}
          filteredValues={filteredValues}
          setMoreInfoSlideOpen={setMoreInfoSlideOpen}
        />
      </SliderPanel>
    </LoaderWrapper>
  );
}

export default WithdrawalRequestContainer;
